export default function mobileOrDesktopFromUserAgent(userAgent = ''): 'mobile' | 'desktop' {
  const safeUserAgent = typeof userAgent === 'string' ? userAgent : ''
  const isMobile = !!safeUserAgent.match(/Mobi/i)
  return isMobile ? 'mobile' : 'desktop'
}
